// AI 单工具页在所有语言路径下只展示黑底版权条，不展示海外官网完整 Footer。
const PSEO_COPYRIGHT_ONLY_SLUG_SET = new Set([
  'ai-cutout',
  'ai-enhance',
  'ai-eraser',
  'ai-watermark',
]);

/**
 * 判断 PSEO 页面是否需要展示海外官网完整 Footer。
 * 多语言路径形如 en/ai-eraser，因此按最终页面 slug 判断，避免语言前缀绕过单工具页规则。
 */
export function shouldShowPseoOverseaFooter(pathKey: string): boolean {
  const normalizedPathKey = pathKey.replace(/^\/+|\/+$/g, '');
  const pathSegments = normalizedPathKey.split('/');
  const pageSlug = pathSegments[pathSegments.length - 1] || '';

  return !PSEO_COPYRIGHT_ONLY_SLUG_SET.has(pageSlug);
}
